module.exports = __webpack_public_path__ + "static/cn-50a3769d8ff3d38a2e7cbabaf043573d.jpg";